// 20-question bilingual career-match quiz for Al-Ahliyya College.
// Each answer awards points to one or more programs.
// Result = program with highest score.

export const PROGRAMS = {
    "base-degree": {
        nameHe: "תואר ראשון בסיסי",
        nameAr: "لقب أول أساسي",
        descHe: "מסלול הכנה כללי · שנתיים · יומיים בשבוע. פתח דלת למגוון תחומים.",
        descAr: "مسار تحضيري عام · سنتان · يومان بالأسبوع. يفتح باب لتخصصات متعددة.",
        icon: "GraduationCap",
        color: "#0B1F3D",
    },
    "nursing-continuation": {
        nameHe: "סיעוד — מסלול המשך",
        nameAr: "تمريض — مسار متابعة",
        descHe: "טיפול ישיר בחולים · עבודה בבתי חולים וקופות חולים · תעסוקה מיידית.",
        descAr: "رعاية مباشرة للمرضى · عمل في المستشفيات · تشغيل فوري بعد التخرج.",
        icon: "Heart",
        color: "#DC2626",
    },
    "radiology-continuation": {
        nameHe: "רנטגן — מסלול המשך",
        nameAr: "أشعة — مسار متابعة",
        descHe: "טכנולוגיית הדמיה · CT, MRI, אולטרסאונד · עבודה עם ציוד מתקדם.",
        descAr: "تكنولوجيا التصوير · CT, MRI, ألتراساوند · العمل بأجهزة متقدمة.",
        icon: "Zap",
        color: "#7C3AED",
    },
    "teaching-cert-continuation": {
        nameHe: "הוראה — תעודת הוראה",
        nameAr: "تربية — شهادة تعليم",
        descHe: "עבודה עם ילדים ונוער · שעות מותאמות · חופשות · השפעה על דורות.",
        descAr: "العمل مع الأطفال والشباب · ساعات مريحة · إجازات · تأثير على أجيال.",
        icon: "BookOpen",
        color: "#059669",
    },
    "mteach": {
        nameHe: "M.Teach — תואר שני ממומן",
        nameAr: "M.Teach — لقب ثاني ممول",
        descHe: "תואר שני בהוראה · ממומן על ידי משרד החינוך · חיסכון של 60,000 ₪.",
        descAr: "لقب ثاني في التربية · ممول من قبل وزارة التربية · توفير 60,000 شيكل.",
        icon: "Award",
        color: "#D4761F",
    },
};

// Each Q: text + array of answers, each answer has {points: {programId: n}}
export const QUESTIONS = [
    {
        id: 1,
        he: "מה הכי מעניין אותך בעבודה?",
        ar: "ما الذي يثير اهتمامك أكثر في العمل؟",
        answers: [
            {
                he: "לעזור לאנשים במצוקה",
                ar: "مساعدة الناس في محنتهم",
                points: { "nursing-continuation": 3, "teaching-cert-continuation": 1 },
            },
            {
                he: "ללמד ולהשפיע",
                ar: "التعليم والتأثير",
                points: { "teaching-cert-continuation": 3, "mteach": 2 },
            },
            {
                he: "לעבוד עם טכנולוגיה מתקדמת",
                ar: "العمل بتكنولوجيا متقدمة",
                points: { "radiology-continuation": 3, "base-degree": 1 },
            },
            {
                he: "אני עוד מתלבט",
                ar: "ما زلت مترددًا",
                points: { "base-degree": 2 },
            },
        ],
    },
    {
        id: 2,
        he: "אתה מרגיש בנוח בסביבה של בית חולים / מרפאה?",
        ar: "هل تشعر بالراحة في بيئة المستشفى / العيادة؟",
        answers: [
            { he: "כן, מאוד", ar: "نعم، جدًا", points: { "nursing-continuation": 3, "radiology-continuation": 2 } },
            { he: "בערך", ar: "نوعًا ما", points: { "nursing-continuation": 1, "radiology-continuation": 1 } },
            { he: "לא ממש", ar: "ليس فعلًا", points: { "teaching-cert-continuation": 2, "mteach": 1 } },
            { he: "ממש לא", ar: "لا أبدًا", points: { "teaching-cert-continuation": 2, "base-degree": 1 } },
        ],
    },
    {
        id: 3,
        he: "עד כמה אתה נהנה לעבוד עם ילדים?",
        ar: "إلى أي مدى تستمتع بالعمل مع الأطفال؟",
        answers: [
            { he: "מאוד! זה הכי מלהיב אותי", ar: "جدًا! هذا أكثر ما يحمّسني", points: { "teaching-cert-continuation": 3, "mteach": 2 } },
            { he: "אני אוהב, בגילים מסוימים", ar: "أحب، بأعمار معينة", points: { "teaching-cert-continuation": 2 } },
            { he: "מעדיף מבוגרים", ar: "أفضل البالغين", points: { "nursing-continuation": 2, "radiology-continuation": 1 } },
            { he: "לא בעל אישיות של עבודה עם ילדים", ar: "ليست شخصيتي", points: { "radiology-continuation": 2, "base-degree": 1 } },
        ],
    },
    {
        id: 4,
        he: "כמה חשוב לך שיהיה שיווי משקל בין עבודה לחיים אישיים?",
        ar: "كم من المهم لك التوازن بين العمل والحياة الشخصية؟",
        answers: [
            { he: "חשוב מאוד — לא רוצה משמרות לילה", ar: "مهم جدًا — لا أريد مناوبات ليلية", points: { "teaching-cert-continuation": 3, "mteach": 2, "base-degree": 1 } },
            { he: "אני גמיש", ar: "أنا مرن", points: { "nursing-continuation": 1, "radiology-continuation": 1 } },
            { he: "מוכן למאמץ בשביל שכר טוב", ar: "مستعد للجهد مقابل أجر جيد", points: { "nursing-continuation": 2, "radiology-continuation": 2 } },
            { he: "עוד לא חשבתי על זה", ar: "لم أفكر بذلك بعد", points: { "base-degree": 2 } },
        ],
    },
    {
        id: 5,
        he: "עד כמה אתה סבלני?",
        ar: "إلى أي مدى أنت صبور؟",
        answers: [
            { he: "מאוד — סבלני עם כל אחד", ar: "جدًا — صبور مع الجميع", points: { "teaching-cert-continuation": 3, "nursing-continuation": 2, "mteach": 2 } },
            { he: "בגדול", ar: "بشكل عام", points: { "nursing-continuation": 1, "teaching-cert-continuation": 1 } },
            { he: "תלוי במצב", ar: "حسب الحالة", points: { "base-degree": 1, "radiology-continuation": 1 } },
            { he: "לא ממש", ar: "ليس فعلًا", points: { "radiology-continuation": 2 } },
        ],
    },
    {
        id: 6,
        he: "מה מרגש אותך יותר — ידיים מלוכלכות בעבודה או משרד נקי?",
        ar: "ما الذي يحمّسك أكثر — العمل الميداني أم المكتب النظيف؟",
        answers: [
            { he: "ידיים מלוכלכות — טיפול ישיר", ar: "العمل الميداني — رعاية مباشرة", points: { "nursing-continuation": 3 } },
            { he: "ציוד מדעי מתקדם", ar: "أجهزة علمية متقدمة", points: { "radiology-continuation": 3 } },
            { he: "לוח לימוד וילדים", ar: "لوح تعليم وأطفال", points: { "teaching-cert-continuation": 3, "mteach": 1 } },
            { he: "משרד וניירת", ar: "مكتب وأوراق", points: { "base-degree": 2 } },
        ],
    },
    {
        id: 7,
        he: "מה חשוב לך יותר בקריירה?",
        ar: "ما الأهم لك في المسيرة المهنية؟",
        answers: [
            { he: "שכר טוב וקידום מהיר", ar: "راتب جيد وتقدم سريع", points: { "nursing-continuation": 2, "radiology-continuation": 2 } },
            { he: "יציבות תעסוקתית", ar: "استقرار وظيفي", points: { "teaching-cert-continuation": 3, "nursing-continuation": 1 } },
            { he: "משמעות ותרומה", ar: "معنى ومساهمة", points: { "teaching-cert-continuation": 2, "nursing-continuation": 2, "mteach": 2 } },
            { he: "אקדמיה והתפתחות אינטלקטואלית", ar: "الأكاديميا والتطور الفكري", points: { "mteach": 3, "base-degree": 2 } },
        ],
    },
    {
        id: 8,
        he: "האם אתה נבהל למראה דם או מחט?",
        ar: "هل تخاف من رؤية الدم أو الإبرة؟",
        answers: [
            { he: "בכלל לא", ar: "لا أبدًا", points: { "nursing-continuation": 3, "radiology-continuation": 1 } },
            { he: "לא נורא", ar: "ليس كثيرًا", points: { "nursing-continuation": 1, "radiology-continuation": 2 } },
            { he: "קצת", ar: "قليلًا", points: { "radiology-continuation": 1, "teaching-cert-continuation": 1 } },
            { he: "מאוד — לא בשבילי", ar: "جدًا — ليس لي", points: { "teaching-cert-continuation": 2, "base-degree": 1, "mteach": 1 } },
        ],
    },
    {
        id: 9,
        he: "כמה מהר אתה קולט חומר לימודי חדש?",
        ar: "ما مدى سرعتك في استيعاب مواد جديدة؟",
        answers: [
            { he: "מהר מאוד", ar: "بسرعة جدًا", points: { "mteach": 3, "radiology-continuation": 2, "base-degree": 1 } },
            { he: "בממוצע", ar: "متوسط", points: { "base-degree": 2, "teaching-cert-continuation": 1 } },
            { he: "צריך זמן", ar: "أحتاج وقتًا", points: { "teaching-cert-continuation": 1 } },
            { he: "אני יותר מעשי מאשר תיאורטי", ar: "أنا عملي أكثر من نظري", points: { "nursing-continuation": 2 } },
        ],
    },
    {
        id: 10,
        he: "אחרי התואר הראשון — האם תרצה להמשיך לתואר שני?",
        ar: "بعد اللقب الأول — هل تريد الاستمرار للقب ثاني؟",
        answers: [
            { he: "בטוח — אני רוצה להתקדם", ar: "بالتأكيد — أريد التقدم", points: { "mteach": 3, "base-degree": 1 } },
            { he: "אולי בעתיד", ar: "ربما في المستقبل", points: { "mteach": 1, "teaching-cert-continuation": 1, "base-degree": 1 } },
            { he: "לא, אני רוצה לצאת לעבודה", ar: "لا، أريد الخروج للعمل", points: { "nursing-continuation": 2, "radiology-continuation": 2 } },
            { he: "עוד לא בטוח", ar: "لست متأكدًا", points: { "base-degree": 2 } },
        ],
    },
    {
        id: 11,
        he: "איך אתה בתקשורת בין-אישית?",
        ar: "كيف أنت في التواصل الشخصي؟",
        answers: [
            { he: "מדבר עם כולם, אוהב אנשים", ar: "أتكلم مع الجميع، أحب الناس", points: { "teaching-cert-continuation": 3, "nursing-continuation": 3 } },
            { he: "טוב עם קרובים", ar: "جيد مع المقربين", points: { "nursing-continuation": 1, "radiology-continuation": 1 } },
            { he: "מעדיף לעבוד לבד", ar: "أفضل العمل وحدي", points: { "radiology-continuation": 2, "base-degree": 2 } },
            { he: "ביישן קצת", ar: "خجول قليلًا", points: { "radiology-continuation": 1, "base-degree": 1 } },
        ],
    },
    {
        id: 12,
        he: "כמה חשוב לך תפקיד עם השפעה חברתית?",
        ar: "كم من المهم لك دور ذو تأثير اجتماعي؟",
        answers: [
            { he: "מאוד חשוב — משנה חיים", ar: "مهم جدًا — يغير الحياة", points: { "teaching-cert-continuation": 3, "nursing-continuation": 3, "mteach": 2 } },
            { he: "חשוב", ar: "مهم", points: { "teaching-cert-continuation": 1, "nursing-continuation": 1 } },
            { he: "פחות חשוב", ar: "أقل أهمية", points: { "radiology-continuation": 1, "base-degree": 1 } },
            { he: "אני מסתכל על הצד הכלכלי", ar: "أنظر للجانب الاقتصادي", points: { "radiology-continuation": 2, "nursing-continuation": 1 } },
        ],
    },
    {
        id: 13,
        he: "מה מעניין אותך יותר?",
        ar: "ما الذي يهمك أكثر؟",
        answers: [
            { he: "אנטומיה ופיזיולוגיה", ar: "التشريح والوظائف", points: { "nursing-continuation": 3, "radiology-continuation": 3 } },
            { he: "פסיכולוגיה וחינוך", ar: "علم النفس والتربية", points: { "teaching-cert-continuation": 3, "mteach": 2 } },
            { he: "מדע וטכנולוגיה", ar: "العلوم والتكنولوجيا", points: { "radiology-continuation": 3, "mteach": 1 } },
            { he: "מגוון תחומים", ar: "مجالات متنوعة", points: { "base-degree": 3 } },
        ],
    },
    {
        id: 14,
        he: "האם אתה מוכן לעבוד בסופ״ש / חגים?",
        ar: "هل أنت مستعد للعمل في العطلات؟",
        answers: [
            { he: "כן — אני צריך את השכר", ar: "نعم — أحتاج للراتب", points: { "nursing-continuation": 3, "radiology-continuation": 1 } },
            { he: "רק לפעמים", ar: "أحيانًا فقط", points: { "nursing-continuation": 1, "radiology-continuation": 1 } },
            { he: "מעדיף שלא", ar: "أفضل عدم ذلك", points: { "teaching-cert-continuation": 2, "mteach": 1 } },
            { he: "בשום אופן לא", ar: "على الإطلاق لا", points: { "teaching-cert-continuation": 3, "base-degree": 1 } },
        ],
    },
    {
        id: 15,
        he: "כמה חשובה לך התפתחות אקדמית מתמשכת?",
        ar: "ما مدى أهمية التطور الأكاديمي المستمر لك؟",
        answers: [
            { he: "מאוד חשוב — לומד כל החיים", ar: "مهم جدًا — أتعلم طوال الحياة", points: { "mteach": 3, "base-degree": 2 } },
            { he: "אחרי סיום, מרווח קצת", ar: "بعد التخرج، استراحة قليلة", points: { "nursing-continuation": 2, "radiology-continuation": 1 } },
            { he: "מספיק עם התואר הראשון", ar: "يكفي اللقب الأول", points: { "nursing-continuation": 1, "radiology-continuation": 2 } },
            { he: "לומד בעבודה, לא בכיתה", ar: "أتعلم في العمل، ليس في الصف", points: { "nursing-continuation": 1, "radiology-continuation": 1 } },
        ],
    },
    {
        id: 16,
        he: "מה סוג הסביבה שהכי מתאים לך?",
        ar: "ما نوع البيئة الأنسب لك؟",
        answers: [
            { he: "שקטה, ממוקדת", ar: "هادئة، مركزة", points: { "radiology-continuation": 3, "base-degree": 1 } },
            { he: "דינמית, מלאה תנועה", ar: "ديناميكية، مليئة بالحركة", points: { "nursing-continuation": 3, "teaching-cert-continuation": 2 } },
            { he: "יצירתית, גמישה", ar: "إبداعية، مرنة", points: { "teaching-cert-continuation": 3, "mteach": 2 } },
            { he: "עוד לא בטוח", ar: "لست متأكدًا", points: { "base-degree": 2 } },
        ],
    },
    {
        id: 17,
        he: "עד כמה אתה טוב בפרטים קטנים ודיוק?",
        ar: "ما مدى مهارتك في التفاصيل والدقة؟",
        answers: [
            { he: "מצוין — פרפקציוניסט", ar: "ممتاز — كمالي", points: { "radiology-continuation": 3, "mteach": 2 } },
            { he: "טוב", ar: "جيد", points: { "radiology-continuation": 1, "nursing-continuation": 2 } },
            { he: "בממוצע", ar: "متوسط", points: { "teaching-cert-continuation": 2, "base-degree": 1 } },
            { he: "אני יותר על הרעיון הגדול", ar: "أنا أكثر على الفكرة العامة", points: { "teaching-cert-continuation": 1, "base-degree": 1 } },
        ],
    },
    {
        id: 18,
        he: "אם היית יכול להשפיע על דור שלם — היית רוצה?",
        ar: "لو كان بإمكانك التأثير على جيل كامل — هل تريد ذلك؟",
        answers: [
            { he: "כן!! זה החלום שלי", ar: "نعم!! هذا حلمي", points: { "teaching-cert-continuation": 3, "mteach": 3 } },
            { he: "כן, זה יפה", ar: "نعم، جميل", points: { "teaching-cert-continuation": 1, "nursing-continuation": 1 } },
            { he: "מעדיף השפעה על אנשים באופן אישי", ar: "أفضل التأثير على الأشخاص شخصيًا", points: { "nursing-continuation": 3 } },
            { he: "פחות מעניין אותי", ar: "أقل اهتمامي", points: { "radiology-continuation": 2, "base-degree": 1 } },
        ],
    },
    {
        id: 19,
        he: "כמה חשוב לך שהמסלול יהיה קצר וישיר לתעסוקה?",
        ar: "كم من المهم أن يكون المسار قصيرًا ومباشرًا للعمل؟",
        answers: [
            { he: "מאוד — רוצה לצאת לעבוד כמה שיותר מהר", ar: "جدًا — أريد العمل بأسرع وقت", points: { "nursing-continuation": 3, "radiology-continuation": 3 } },
            { he: "חשוב", ar: "مهم", points: { "teaching-cert-continuation": 2, "nursing-continuation": 1 } },
            { he: "לא כזה חשוב, מוכן להשקיע זמן", ar: "ليس مهمًا جدًا، مستعد للاستثمار", points: { "mteach": 3, "base-degree": 2 } },
            { he: "לגמרי לא — רוצה ללמוד לעומק", ar: "لا أبدًا — أريد التعلم بعمق", points: { "mteach": 3 } },
        ],
    },
    {
        id: 20,
        he: "מה הייתי אומר על עצמך ב-3 מילים?",
        ar: "ماذا كنت لتقول عن نفسك في 3 كلمات؟",
        answers: [
            { he: "אכפתי, חם, קשוב", ar: "مهتم، دافئ، منتبه", points: { "nursing-continuation": 3, "teaching-cert-continuation": 2 } },
            { he: "יסודי, מדויק, מקצועי", ar: "دقيق، منهجي، مهني", points: { "radiology-continuation": 3, "mteach": 2 } },
            { he: "מעורר השראה, סבלני, יצירתי", ar: "ملهم، صبور، إبداعي", points: { "teaching-cert-continuation": 3, "mteach": 3 } },
            { he: "סקרן, פתוח, גמיש", ar: "فضولي، منفتح، مرن", points: { "base-degree": 3, "mteach": 1 } },
        ],
    },
];
